import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "cl-layout"
}
const _hoisted_2 = { class: "cl-main" }
const _hoisted_3 = { class: "cl-content" }
const _hoisted_4 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LayoutComponent = _resolveComponent("LayoutComponent")!
  const _component_AppBarComponent = _resolveComponent("AppBarComponent")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_ctx.isSettingPage())
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_LayoutComponent, {
          onToggle: _ctx.toggleSidebar,
          ref: "layoutRef"
        }, null, 8, ["onToggle"]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_AppBarComponent, {
            language: _ctx.lang,
            multilang: _ctx.multilang,
            onLangchange: _ctx.languageChange,
            onLogout: _ctx.logOut,
            onToggle: _ctx.toggleSidebar
          }, null, 8, ["language", "multilang", "onLangchange", "onLogout", "onToggle"]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_router_view)
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
        _createVNode(_component_router_view)
      ]))
}